module.exports = __webpack_public_path__ + "static/media/Group122.eb514dc2.png";